import type { MouseEventHandler } from 'react';

import { Drawer } from '@mui/material';

import Chat from '@/features/AIChat/AskGXDrawer/Chat/Chat';
import Header from '@/features/AIChat/AskGXDrawer/Header/Header';
import MessageInput from '@/features/AIChat/AskGXDrawer/MessageInput/MessageInput';
import { ChatProvider } from '@/features/AIChat/context/ChatProvider';

const AskGXInner = ({ onClose }: { onClose: MouseEventHandler }) => {
  return (
    <>
      <Header onClose={onClose} />
      <Chat />
      <MessageInput maxRows={3} />
    </>
  );
};

const AskGXDrawer = ({ open, onClose }: { open: boolean; onClose: MouseEventHandler }) => {
  return (
    <Drawer
      anchor='right'
      ModalProps={{ keepMounted: true }}
      open={open}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: 'rgba(18, 22, 63, 0.80)',
            backdropFilter: 'blur(2px)'
          }
        }
      }}
      sx={{
        width: '846px',
        left: 'auto',
        display: 'flex',
        flexDirection: 'column'
      }}
      onClose={onClose}
    >
      <ChatProvider open={open}>
        <AskGXInner onClose={onClose} />
      </ChatProvider>
    </Drawer>
  );
};

export default AskGXDrawer;
